<template>
  <div>
    <div class="app-header clearfix">
      <el-form :inline="true" class="float-left">
        <el-form-item label="状态">
          <el-select v-model="listQuery.status" placeholder="请选择状态" class="w-160px">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="onReset()">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button
        type="primary"
        class="float-right"
        :loading="refreshBtnLoading"
        :disabled="!selectedData.length"
        @click="handleRefresh()"
      >刷新状态</el-button>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="tableDataLoading"
      :data="tableData"
      border
      stripe
      highlight-current-row
      class="w-full"
      @selection-change="handleSelection"
    >
      <el-table-column type="selection" align="center" width="55" />
      <el-table-column label="开票时间" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.invoicingDate | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="billName" label="单据名称" />
      <el-table-column prop="drawer" label="开票人" />
      <el-table-column prop="invoiceType" label="发票种类" />
      <el-table-column prop="customerName" label="客户名称" />
      <el-table-column prop="invoiceCode" label="发票代码" />
      <el-table-column prop="invoiceNumber" label="发票号码" />
      <el-table-column prop="taxNumber" label="纳税人识别号" min-width="160" />
      <el-table-column prop="taxAmt" label="含税金额" />
      <el-table-column prop="taxFreeAmt" label="不含税金额" />
      <el-table-column prop="tax" label="税额" />
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span
            :class="[
              {
                'text-color-success': scope.row.status === '成功',
                'text-color-fail': isShowMessage(scope.row.status),
              },
            ]"
          >{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作人" />
      <el-table-column label="失败原因">
        <template slot-scope="scope">
          <span v-if="isShowMessage(scope.row.status)" class="text-color-fail">{{ scope.row.message }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix">
      <div class="pagination-container float-right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.pageNum"
          background
          :page-sizes="[10, 20, 40, 60, 100]"
          :page-size="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { statusList } from "@/data";
import { parseTime } from "@/utils/index";
import { isShowMessage } from "@/utils/common";
import { getElectronicBlueRecordList, refreshElectronicBlueStatus } from "@/api/invoiceApi";
export default {
  filters: {
    parseTime
  },
  data() {
    return {
      statusList,
      refreshBtnLoading: false,
      tableDataLoading: false,
      listQuery: {
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      tableData: [],
      selectedData: []
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.tableDataLoading = true;
      getElectronicBlueRecordList(this.listQuery).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.rows;
          this.total = res.data.total;
          this.tableDataLoading = false;
        }
      });
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.fetchData();
    },
    onSearch() {
      this.listQuery.pageNum = 1;
      this.fetchData();
    },
    onReset() {
      this.listQuery = {
        status: null,
        pageNum: 1,
        pageSize: 10
      };
      this.fetchData();
    },
    handleSelection(val) {
      this.selectedData = val;
    },
    handleRefresh() {
      const ids = [];
      this.selectedData.forEach(item => {
        ids.push(item.id);
      });
      this.refreshBtnLoading = true;
      refreshElectronicBlueStatus({ idList: ids.join(",") })
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg);
            this.fetchData();
          } else {
            this.$message.error(res.data.msg || "刷新失败，请重试");
          }
          this.refreshBtnLoading = false;
        })
        .catch(() => {
          this.refreshBtnLoading = false;
        });
    },
    isShowMessage
  }
};
</script>
